import workspaceQuery from '../../../graphql/queries/sales/ProformaInvoiceWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/sales/ProformaInvoiceListQuery.graphql';
import instanceQuery from '../../../graphql/queries/sales/ProformaInvoiceQuery.graphql';
import fragment from '../../../graphql/fragments/sales/ProformaInvoiceFragment.graphql';

import generateMutation from '../../../graphql/mutations/sales/ProformaInvoiceGenerateMutation.graphql';
import generateRangeMutation from '../../../graphql/mutations/sales/ProformaInvoiceGenerateRangeMutation.graphql';
import reprintMutation from '../../../graphql/mutations/sales/ProformaInvoiceReprintMutation.graphql';

import * as printFunctions from '../../../actions/sales/ProformaInvoiceAction';
import { salesDocument } from '../../../utils/mailMergeFields';
import { ReportType } from '../../schema/p4types';
import { EntityType } from '../../../@types/entityTypes';

const ProformaInvoice: EntityType = {
  type: 'ProformaInvoice',
  title: 'Proforma Invoice',
  formUrl: '/Sales/ProformaInvoices/Form/',
  formTitle: 'Print Proforma Invoices',
  workspaceUrl: '/Sales/ProformaInvoices/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  generate: generateMutation,
  generateRange: generateRangeMutation,
  reprint: reprintMutation,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'documentSuffix',
  },
  fragment,
  printFunctions: printFunctions,
  screenReference: 'SALES_DOCUMENTS_PRINT_PROFORMA',
  configuration: {
    title: 'Proforma Invoice',
    field: 'proformaInvoiceDocumentDefault',
    reportType: ReportType.ProformaInvoice,
    customerField: 'customerProformaInvoiceDocumentDefault',
    receiveFlag: 'receiveProformaInvoiceDocuments',
  },
  operations: 0,
  mergeFields: [
    ...salesDocument,
    {
      key: 'payByLink',
      text: 'Pay by Link URL',
    },
  ],
};

export default ProformaInvoice;
